import { render, staticRenderFns } from "./detail_discount.vue?vue&type=template&id=70ee56f2&scoped=true"
import script from "./detail_discount.vue?vue&type=script&lang=js"
export * from "./detail_discount.vue?vue&type=script&lang=js"
import style0 from "./detail_discount.vue?vue&type=style&index=0&id=70ee56f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee56f2",
  null
  
)

export default component.exports